/**
 * アップロード検知の「何ができて、何ができないか」(docs/dlp-upload.md §1)と経路ごとの見え方(§4.6)。
 * 一覧の上の 1 行から開くポップオーバー。文言は README と同じものを使う。
 */
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Popover, Table, Typography } from "antd";

const { Text } = Typography;

const ROUTES = [
  { route: "OS の DNS + TCP(HTTP/1.1・2)", bytes: "取れる", name: "取れる", block: "ブラウザなら可" },
  { route: "OS の DNS + QUIC(HTTP/3、UDP 443)", bytes: "取れる(UDP 送信)", name: "取れる", block: "ブラウザなら可" },
  { route: "ブラウザの DoH", bytes: "取れる", name: "取れない → 設定の「DoH を切る」で切る", block: "ブラウザなら可" },
  { route: "アプリ独自の DNS / DoH", bytes: "取れる", name: "取れない(宛先不明の大量送信のみ)", block: "不可" },
  { route: "HTTP / SOCKS プロキシ経由", bytes: "プロキシ宛ての量", name: "プロキシ名", block: "ブラウザなら可" },
  { route: "VPN", bytes: "トンネル宛て + 内側(二重計上の可能性)", name: "内側は取れることがある", block: "ブラウザなら可" },
];

function HelpBody() {
  return (
    <div style={{ maxWidth: 560, fontSize: 13 }}>
      <Text strong>できる</Text>
      <ul style={{ margin: "4px 0 8px", paddingLeft: 20 }}>
        <li>一覧に載ったクラウドストレージ・ファイル転送サービス宛ての推定送信量を、プロセス単位・窓(既定 5 分)単位で記録する</li>
        <li>窓あたりの送信量が閾値(既定 1MiB)以上のものだけを「検知」として残す。一般の閲覧履歴は送らない・残さない</li>
        <li>一覧に当たらない宛先でも、窓あたり大量(既定 100MiB)に送ったものは「宛先不明の大量送信」として残す</li>
        <li>遮断にしたドメインを、対応ブラウザ(Chrome / Edge / Firefox)で開けなくする(設定の「ブラウザで遮断する」が有効なとき)</li>
      </ul>
      <Text strong>できない・推定にとどまる</Text>
      <ul style={{ margin: "4px 0 8px", paddingLeft: 20 }}>
        <li>送った中身・ファイル名は分からない(TLS を復号しない)。送信量は「その宛先へ送ったバイト数」で、アップロードの確証ではない</li>
        <li>宛先 IP を複数のサービスが共有している場合、どのサービス宛てか決まらないことがある。その場合は帰属「推定」として記録する</li>
        <li>社内プロキシ・VPN 経由の通信は、宛先がプロキシ / VPN の IP になるため一覧に当たらない</li>
        <li>ブラウザ以外(同期クライアント・コマンドライン)は止められない。管理者権限を持つ利用者による停止・改ざんは防げない</li>
        <li>利用者は端末の割当。「その従業員が送った」とは断定できない</li>
      </ul>
      <Text strong>経路ごとの見え方</Text>
      <Table
        scroll={{ x: "max-content" }}
        size="small"
        style={{ marginTop: 4 }}
        rowKey="route"
        pagination={false}
        dataSource={ROUTES}
        columns={[
          { title: "経路", width: 160, dataIndex: "route" },
          { title: "量", width: 90, dataIndex: "bytes" },
          { title: "宛先の名前", width: 240, dataIndex: "name" },
          { title: "遮断", width: 90, dataIndex: "block" },
        ]}
      />
      <Text type="secondary" style={{ display: "block", marginTop: 6 }}>
        社内プロキシ環境では、プロキシ / ゲートウェイのログ連携を別途勧める(v0 の範囲外)。
      </Text>
    </div>
  );
}

/** 「できること・できないこと」のポップオーバーを開くリンク */
export function UploadHelp() {
  return (
    <Popover content={<HelpBody />} title="アップロード検知でできること・できないこと" trigger="click" placement="bottomLeft">
      <Button type="link" size="small" icon={<QuestionCircleOutlined />} style={{ padding: 0, height: "auto" }}>
        できること・できないこと
      </Button>
    </Popover>
  );
}
